<template>
  <main id="register-independent-wrapper">

    <div v-if="loadderforms" class="loading loading-double"></div>
    <div v-else id="registerpage">
      <breadcrumb
        :breadcrumb="[
          { title: 'Community', url: app_url, status: false },
          { title: 'Registrasi Form', url: app_url+'/register/independent', status: true },
        ]"
      ></breadcrumb>
      <div class="container-fluid title-row text-center">
        <div class="container">
          <div class="row py-3">
            <div class="col">
              <h2>Registrasi Form</h2>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid title-row-info text-center">
        <div class="container">
          <div class="row py-3">
            <div class="colpage">
                <div class="pageform" :class="{active : page == 1 || page > 1}">
                    <span class="numberpage">1</span>
                    <span class="infopage">Informasi Data Diri</span>
                </div>
                <span class="arrow-right"><img :src="base_url+'/images/arrow-right.png'" alt="arrow"></span>
                <div class="pageform" :class="{active : page == 2}">
                    <span class="numberpage">2</span>
                    <span class="infopage">Verifikasi OTP & Buat PIN</span>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container py-5" id="dataform" v-if="page == 1">
        <div class="row justify-content-center">
          <div class="col-md-12">
            <form
                method="POST"
                @submit.prevent="onSubmit"
                @keydown="form.errors.clear($event.target.name)"
                enctype="multipart/form-data"
            >
              <div class="card">
                <div class="card-body">
                    <div class="form-group row" :id="form.errors.has('name') ? 'error-field' : false">
                      <div class="col">
                        <label class="label-form" for="nama">Nama</label>
                        <input
                          type="text"
                          class="form-control form-register"
                          id="nama"
                          aria-describedby="nama"
                          v-model="form.name"
                          placeholder="Masukkan Nama"
                        />
                          <span
                          class="help-block"
                          v-if="form.errors.has('name')"
                          v-text="form.errors.get('name')"
                          >
                          </span>
                      </div>
                    </div>
                    <div class="form-group row" :id="form.errors.has('email') ? 'error-field' : false">
                      <div class="col">
                        <label class="label-form" for="email">Email</label>
                        <input
                          type="email"
                          class="form-control form-register"
                          aria-describedby="email"
                          placeholder="Masukkan Email"
                          v-model="form.email"
                        />
                          <span
                          class="help-block"
                          v-if="form.errors.has('email')"
                          v-text="form.errors.get('email')"
                          >
                          </span>
                      </div>
                    </div>
                    <div class="form-group row" :id="form.errors.has('phone') ? 'error-field' : false">
                      <div class="col">
                        <label class="label-form" for="hp">No. Handphone</label>
                          <div class="phonebox">
                              <span class="input62">+62</span>
                              <input
                                  type="number"
                                  class="form-control form-register"
                                  id="hp"
                                  aria-describedby="hp"
                                  placeholder="8XXXXXXXX"
                                  v-model="form.phone"
                              />
                          </div>
                          <span
                          class="help-block"
                          v-if="form.errors.has('phone')"
                          v-text="form.errors.get('phone')"
                          >
                          </span>
                          <small class="text-black" v-else>Contoh isian no. handphone: 82112345678</small>
                      </div>
                    </div>
                    <div class="form-group row" :id="form.errors.has('province_id') ? 'error-field' : false">
                      <div class="col">
                        <label class="label-form" for="province_id">Provinsi Domisili</label>
                          <div class="custom_vselect custom_vselect-large">
                              <v-select
                                  :options="provinces"
                                  label="name"
                                  :placeholder="provincePlaceholder"
                                  @input="changeProvince($event,'province_id','city_id')"
                                  v-model="province_id"
                              >
                              </v-select>
                          </div>
                          <span
                          class="help-block"
                          v-if="form.errors.has('province_id')"
                          v-text="form.errors.get('province_id')"
                          >
                          </span>
                      </div>
                    </div>
                    <div class="form-group row" :id="form.errors.has('city_id') ? 'error-field' : false">
                      <div class="col">
                        <label class="label-form" for="city_id">Kota Domisili</label>
                          <div class="custom_vselect custom_vselect-large">
                          <v-select
                              :options="cities"
                              label="name"
                              :placeholder="cityPlaceholder"
                              @input="changeCity($event,'city_id')"
                              v-model="city_id"
                          >
                          </v-select>
                          </div>
                          <span
                          class="help-block"
                          v-if="form.errors.has('city_id')"
                          v-text="form.errors.get('city_id')"
                          >
                          </span>
                      </div>
                    </div>
                    <div class="form-group row" :id="form.errors.has('club_name1') ? 'error-field' : false">
                      <div class="col">
                        <label class="label-form" for="nama-komunitas"
                          >Nama Komunitas</label
                        >
                        <div class="custom_vselect custom_vselect-large">

                          <auto-search
                          class="auto-search"
                          v-model="club_name1"
                          :data="clubs"
                          :serializer="(item) => item.name"
                          @hit="changeClub($event,'club_name1')"
                          :placeholder="clubPlaceholder"
                          />
                          </div>
                          <span class="note">Anda bisa mencari komunitas atau membuat nama komunitas baru dengan mengetik pada kotak input di atas ini.</span>
                          <span
                          class="help-block"
                          v-if="form.errors.has('club_name1')"
                          v-text="form.errors.get('club_name1')"
                          >
                          </span>
                      </div>
                    </div>
                    <div class="form-group row" :id="form.errors.has('bike_category') ? 'error-field' : false">
                      <div class="col">
                        <label class="label-form" for="type">Motor Yang Dimiliki</label>
                          <div class="custom_vselect custom_vselect-large">
                          <v-select
                              :options="motorCategories"
                              label="title"
                              :placeholder="motorCategoryPlaceholder"
                              @input="changeMotorCategory($event,'bike_category','motor_id')"
                              v-model="bike_category"
                          >
                          </v-select>
                          </div>
                          <span
                          class="help-block"
                          v-if="form.errors.has('bike_category')"
                          v-text="form.errors.get('bike_category')"
                          >
                          </span>
                      </div>
                    </div>
                    <div class="form-group row" :id="form.errors.has('motor_id') ? 'error-field' : false">
                      <div class="col">
                        <label class="label-form" for="type">Varian Motor</label>
                          <div  v-if="form.bike_category != 'lain-lain'" class="custom_vselect custom_vselect-large">
                          <v-select
                              :options="varianMotors"
                              label="title"
                              :placeholder="varianMotorPlaceholder"
                              @input="changeVarianMotor($event,'motor_id')"
                              v-model="motor_id"
                          >
                          </v-select>
                          </div>
                          <div v-else>
                              <input
                                  type="text"
                                  class="form-control form-register"
                                  id="motor_id"
                                  aria-describedby="motor_id"
                                  v-model="form.motor_id"
                                  placeholder="Varian Motor"
                              />
                          </div>
                          <span
                          class="help-block"
                          v-if="form.errors.has('motor_id')"
                          v-text="form.errors.get('motor_id')"
                          >
                          </span>
                      </div>
                    </div>
                    <div class="form-group row" :id="form.errors.has('motor_year') ? 'error-field' : false">
                      <div class="col">
                        <label class="label-form" for="type">Tahun Pembuatan Motor</label>
                          <div class="custom_vselect custom_vselect-large">
                            <v-select
                                :options="years"
                                label="title"
                                placeholder="Pilih tahun pembuatan motor"
                                :disabled="years.length === 0"
                                v-model="form.motor_year"
                            >
                            </v-select>
                          </div>
                          <span
                            class="help-block"
                            v-if="form.errors.has('motor_year')"
                            v-text="form.errors.get('motor_year')"
                          >
                          </span>
                      </div>
                    </div>
                    <div class="form-check form-group row" :id="form.errors.has('agree') ? 'error-field' : false">
                      <div class="col">
                        <input type="checkbox" class="form-check-input" id="term" v-model="form.agree" />
                        <label class="form-check-label" for="term" v-html="pagePrivacy.summary"></label>
                        <span
                          class="help-block"
                          v-if="form.errors.has('agree')"
                          v-text="form.errors.get('agree')"
                        >
                        </span>
                      </div>
                    </div>
                    <!-- <div class="form-check form-group row" :id="form.errors.has('agree_tnc') ? 'error-field' : false">
                      <div class="col">
                        <input type="checkbox" class="form-check-input" id="term" v-model="form.agree_tnc" />
                        <label class="form-check-label" for="term">
                          Saya telah membaca, memahami, dan menyetujui <a @click.prevent="showTerm" href="#"><strong><u>Syarat dan Ketentuan</u></strong></a>
                        </label>
                        <span
                          class="help-block"
                          v-if="form.errors.has('agree_tnc')"
                          v-text="form.errors.get('agree_tnc')"
                        >
                        </span>
                      </div>
                    </div> -->
                    <div class="row justify-content-center">
                      <div v-if="submitLoader" class="loading loading-double"></div>
                      <button v-else  type="button" @click="nextAction(2)" class="btn mx-2 btn-red">Selanjutnya</button>
                    </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- Template untuk OTP Mulai dari sini -->
      <div class="container py-5" id="dataform" v-if="page == 2">
        <div class="row justify-content-center">
          <div class="col-md-12 otp-column">
              <div class="card otp-card">
                <div class="card-body otp-card-body">
                    <!-- <div class="form-group row mb-5" :id="form.errors.has('otp_number') ? 'error-field' : false">
                      <div class="col otp-text-left">
                        <label class="mb-2 label-form-otp" for="otp">Masukkan Kode Verifikasi</label>
                        <div class="mb-2 otp-desc">OTP akan dikirimkan ke</div>
                        <div class="mb-5 otp-number">(+62) {{ phoneNumber }}</div>
                        <div ref="otpCont" class="text-center otp-digit-wrapper">
                          <input
                            type="text"
                            class="digit-box mx-1"
                            v-for="(el, ind) in digits"
                            :key="ind"
                            v-model="digits[ind]"
                            :autofocus="ind === 0"
                            maxlength="1"
                            @keydown="handleKeyDown($event, ind)"
                            :class="{ bounce: digits[ind] !== null }"
                            />
                        </div>
                        <span
                          class="help-block"
                          v-if="form.errors.has('otp')"
                          v-text="form.errors.get('otp')"
                        ></span>
                      </div>
                    </div> -->
                    <div class="form-group row mb-3" :id="form.errors.has('otp_number') ? 'error-field' : false">
                      <div class="col otp-text-left">
                        <h3 class="mb-3 label-form-otp" for="otp">Verifikasi</h3>
                        <p class="mb-2 otp-desc">OTP akan dikirimkan ke</p>
                        <p class="mb-3 otp-number">(+62) {{ phoneNumber }}</p>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col">
                        <label class="label-form" for="otp_number">Kode OTP</label>
                        <input
                            type="number"
                            class="form-control form-register"
                            id="otp_number"
                            aria-describedby="otp_number"
                            placeholder="Masukkan No OTP"
                            v-model="otpForm.otp_number"
                            v-mask="'######'"
                            @input="validateNumberInput('otp_number')"
                            @keydown="preventInvalidKey"
                        />
                        <span
                          class="help-block"
                          v-if="otpForm.errors.has('otp_number')"
                          v-text="otpForm.errors.get('otp_number')"
                        >
                        </span>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col">
                        <label class="label-form" for="pin">Masukkan PIN Baru</label>
                        <input
                            type="number"
                            class="form-control form-register"
                            id="pin"
                            aria-describedby="pin"
                            placeholder="Masukkan 6 Digit PIN Baru"
                            v-model="otpForm.pin"
                            v-mask="'######'"
                            @input="validateNumberInput('pin')"
                            @keydown="preventInvalidKey"
                        />
                        <span
                          class="help-block"
                          v-if="otpForm.errors.has('pin')"
                          v-text="otpForm.errors.get('pin')"
                        >
                        </span>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col">
                        <label class="label-form" for="hp">Konfirmasi Pin</label>
                        <input
                            type="number"
                            class="form-control form-register"
                            id="pin_confirmation"
                            aria-describedby="pin_confirmation"
                            placeholder="Konfirmasi Pin"
                            v-model="otpForm.pin_confirmation"
                            v-mask="'######'"
                            @input="validateNumberInput('pin_confirmation')"
                            @keydown="preventInvalidKey"
                        />
                        <span
                          class="help-block"
                          v-if="otpForm.errors.has('pin_confirmation')"
                          v-text="otpForm.errors.get('pin_confirmation')"
                        >
                        </span>
                      </div>
                    </div>
                    <div v-if="submitLoader" class="loading loading-double"></div>
                    <div  v-else class="row-button">
                      <div class="sendback mb-2">
                        <button @click="resendOtp" type="button" class="btn w-100 btn-black" :disabled="countdown != 0">
                          Kirim Ulang OTP
                        </button>
                        <small class="text-black" v-if="countdown > 0"> Kirim Ulang OTP Dalam <strong>{{countdown}}</strong> Detik</small>
                      </div>
                      <button @click="onSubmitOtp" type="button" class="btn w-100 btn-red" style="margin:0">
                        Verifikasi
                      </button>
                    </div>
                    <!-- <div class="row justify-content-center">
                      <div v-if="submitLoader" class="loading loading-double"></div>
                      <button v-else @click="onSubmitOtp" type="button" class="btn w-100 btn-red">Submit</button>
                    </div>
                    <div class="text-center mt-4 otp-countdown">
                      <span v-if="countdown > 0">Mohon tunggu <strong class="text-black">{{ countdown }}</strong> detik untuk kirim ulang.</span>
                      <span v-else><a href="#" @click.prevent="resendOtp">Kirim Ulang OTP</a></span>
                    </div> -->
                </div>
              </div>
          </div>
        </div>
      </div>
      <popup-register-independent-tnc ref="popupTnc"></popup-register-independent-tnc>
    </div>
  </main>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import BreadCrumb from "../../widget/BreadCrumb";
import PopupImage from '../../widget/PopupImage'
import 'vue-select/dist/vue-select.css';
import vSelect from "vue-select";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import PopupRegisterIndependentTnc from "../../widget/PopupRegisterIndependentTnc.vue";
import { sha256, sha224 } from 'js-sha256';


export default {
  components: {
    breadcrumb: BreadCrumb,
    "v-select": vSelect,
    "popup-image": PopupImage,
    "auto-search": VueBootstrapTypeahead,
    "popup-register-independent-tnc": PopupRegisterIndependentTnc
  },
  data() {
    return {
        base_url:'',
        app_url:'',
        api_url:'',
        main_site_url:main_site_url,
        mobile: false,
        page: 1,
        token:'',
        provinces:[],
        province_id:'',
        provincePlaceholder:'Pilih Provinsi',
        club_provinsi1:'',
        provinceClub1Placeholder:'Pilih Provinsi',
        club_provinsi2:'',
        provinceClub2Placeholder:'Pilih Provinsi',
        cities:[],
        city_id:'',
        cityPlaceholder:'Pilih Kota',
        club_city1:'',
        cityClub1Placeholder:'Pilih Kota',
        club_city2:'',
        cityClub2Placeholder:'Pilih Kota',
        motor_types:[],
        bike_category:'',
        club_tipe_motor1:'',
        club_tipe_motor2:'',
        motorPlaceholder:'Pilih Tipe Motor',
        clubs:[],
        club_name1:'',
        club_name2:'',
        clubPlaceholder:'Pilih Nama Komunitas',
        clubPlaceholder2:'Pilih Nama Komunitas',
        hobbies:['Foto','Video','Grafiti','Food','Music','Sport','Modif','Movies','Traveling'],
        hobi:'',
        hobiPlaceholder:'Pilih Hobi',
        varianMotors:[],
        motor_id:'',
        varianMotorPlaceholder:'Pilih Varian Motor',
        varianMotorPlaceholderClub1:'Pilih Varian Motor',
        varianMotorPlaceholderClub2:'Pilih Varian Motor',
        motorCategories:[],
        motor_category:'',
        motor_category_club1:'',
        motor_category_club2:'',
        motorCategoryPlaceholder:'Pilih Kategori Motor',
        motorCategoryPlaceholderClub1:'Pilih Kategori Motor',
        motorCategoryPlaceholderClub2:'Pilih Kategori Motor',
        loadderforms:true,
        submitLoader:false,
        tokenForm: new Form({
            token:'',
        }),
        user:null,
        tmpform: {},
        years: [],
        year: null,
        form: new Form({
          _token : token,
          name:'',
          email:'',
          phone:'',
          province_id:'',
          city_id:'',
          bike_category:'',
          motor_id:'',
          motor_year: '',
          club_name1:'',
          agree:'',
          agree_tnc: '',
          ref: '',
          register_from_event: '',
        }),
        otpForm: new Form({
          _token : token,
          otp_number: '',
          pin: '',
          pin_confirmation: '',
          form_id: '',
          name:'',
          email:'',
          phone:'',
          province_id:'',
          city_id:'',
          bike_category:'',
          motor_id:'',
          motor_year: '',
          club_name1:'',
          agree:'',
          agree_tnc: '',
          motor_name: '',
          province_name: '',
          city_name: '',
          phone_number: '',
          ref: '',
          register_from_event: '',
        }),
        resendOtpForm: new Form({
          _token : token,
          form_id: '',
          name:'',
          email:'',
          phone:'',
          province_id:'',
          city_id:'',
          bike_category:'',
          motor_id:'',
          motor_year: '',
          club_name1:'',
          agree:'',
          agree_tnc: '',
          motor_name: '',
          province_name: '',
          city_name: '',
          phone_number: '',
          ref: '',
          register_from_event: '',
        }),
        digits: Array(6).fill(null),
        countdown: 60,
        otpNumber: '',
        phoneNumber: '',
        pageContent: {},
        pagePrivacy: {},
        redirectUrl: null,
        successPageUrl: `${app_url}/register/independent/success-register`
    };
  },
  watch: {
    club_name1(newQuery) {
        this.form.club_name1 = newQuery;
        axios.get(api_url+`/static/community?name=${newQuery}`)
          .then((response) => {
            this.clubs = response.data.data.community;
          });
    },
    club_name2(newQuery) {
        this.form.club_name2 = newQuery;
        axios.get(api_url+`/static/community?name=${newQuery}`)
          .then((response) => {
            this.clubs = response.data.data.community;
          });
    },
  },
  created() {
    this.base_url = base_url;
    this.app_url = app_url;
    this.api_url = api_url;
    this.mobile = isMobile;
    this.fetchPagePrivacy();
    this.getProvince();
    this.getMotor();
    this.getMotorCategory();
    this.getYear();
    this.fetchPage();
    this.form.ref = localStorage.getItem('utmname') ?? '-';

    if (this.$route.query.redirect !== undefined) {
        let route = this.$route.query.redirect;
        const lastPath = route.split('/').pop();

        this.redirectUrl = route;
        this.successPageUrl = `${this.successPageUrl}?redirect=${this.redirectUrl}`
        this.form.register_from_event = lastPath;
    }
    // if(localStorage.getItem('user') != null){
    //     this.user = JSON.parse(localStorage.getItem('user'));
    //     this.page = 1;
    //     this.defaulUser();
    // }
  },
  methods: {
    showImage(){
        var data = {
            title : 'STNK',
            asset : {
                original : base_url+'/images/stnk.png'
            }
        }
        this.$refs.popupImage.show(data)
    },
    showTerm() {
      const data = this.pageContent
      this.$refs.popupTnc.show(data)
    },
    handleKeyDown(event, index) {
      if (
        event.key !== 'Tab' &&
        event.key !== 'ArrowRight' &&
        event.key !== 'ArrowLeft'
      ) {
        event.preventDefault();
      }

      if (event.key === 'Backspace') {
        this.$set(this.digits, index, null);

        if (index !== 0) {
          this.$refs.otpCont.children[index - 1].focus();
        }

        return;
      }

      if (/^([0-9])$/.test(event.key)) {
        this.$set(this.digits, index, event.key);

        if (index !== this.digits.length - 1) {
          this.$refs.otpCont.children[index + 1].focus();
        }

        if (this.isDigitsFull()) {
          this.otpNumber = this.digits.join('');
        }
      }
    },
    isDigitsFull() {
      return this.digits.every(elem => elem !== null && elem !== undefined);
    },
    startCountdown() {
      const interval = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(interval);
        }
      }, 1000);
    },
    resendOtp() {
      for (const [key, value] of Object.entries(this.tmpform)) {
        if (key !== '_token') this.resendOtpForm[key] = value;
      }

      this.resendOtpForm.post(api_url+"/member/register/independent/resend-otp")
        .then((response) => {
          console.log(response);
          this.countdown = 60;
          this.startCountdown();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onSubmit(page) {
      this.submitLoader = true;

      this.form.post(api_url+"/member/register/independent")
        .then((response) => {
          this.submitLoader = false
          this.tmpform = response.data
          this.phoneNumber = response.data.phone
          this.trackerRegisterIndependent(false, 'Submit Form Registration HCID Independent', response.data)
          this.page = 2;
          this.startCountdown();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        })
        .catch((error) => {
            this.submitLoader = false;
            document.getElementById('error-field').scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
            console.log(error);
        });
    },
    onSubmitOtp() {
      this.submitLoader = true;

      for (const [key, value] of Object.entries(this.tmpform)) {
        if (key !== '_token') this.otpForm[key] = value;
      }

      // this.otpForm.otp_number = this.otpNumber;
      
      this.otpForm.post(api_url+"/member/register/independent/otp")
        .then((response) => {
          this.submitLoader = false
          localStorage.setItem('register-independent-success',JSON.stringify({data: response.data, datalayer: response.datalayer}))
          this.trackerRegisterIndependent(true, 'Submit OTP Registration HCID Independent', response.datalayer)

          window.location.href = this.successPageUrl
        })
        .catch((error) => {
            this.submitLoader = false;
            console.log(error);
        });
    },
    trackerRegisterIndependent(isOtpSubmission, eventLabel, submission) {
      const data = {
        'event': 'registrationHCIDIndependent',
        'eventCategory': 'Registration',
        'eventAction': 'Registration HCID Independent',
        'eventLabel': eventLabel,
        'name': submission.name, // Open without encryption
        'email': submission.email,// Open without encryption
        'phone': submission.phone_number, // Open without encryption
        'selectedProvince': submission.province_name ?? null,
        'selectedCity': submission.city_name ?? null,
        'communityName': submission.club_name1 ?? null, // Naming of the community
        'ownedMotor': submission.bike_category ? submission.bike_category[0].toUpperCase() + submission.bike_category.slice(1) : null,
        'motorVariant': submission.motor_name ?? null,
        'manufactureYear': parseInt(submission.motor_year),
      }

      if (isOtpSubmission) {
        data['formId'] = submission.form_id
      }

      console.log('tracker register independent = ', data)
      dataLayer.push(data);
    },
    validateNumberInput(field) {
      const value = this.otpForm[field];
      this.otpForm[field] = value.slice(0, 6);
    },
    preventInvalidKey(event) {
      const invalidChars = ['-', 'e', '+', '.'];
      if (invalidChars.includes(event.key)) {
        event.preventDefault();
      }
    },
    nextAction(page) {
      this.onSubmit(page);
    },
    backAction(page){
      this.page = page;
    },
    async fetchPagePrivacy() {
        try {
            const response = await axios.get(
                `${api_mainsite_url}/page/type/persetujuan-privasi`
            );

            this.pagePrivacy = response.data;
        } catch (error) {
            console.log(error);
        }
    },
    getYear() {
      const currentYear = new Date().getFullYear();

      const years = [];

      for (let i = currentYear; i >= 1948; i--) {
        years.push(i);
      }

      this.years = years;
    },
    changeYear(event) {
      if (event) {
        this.form.motor_year = event;
      } else {
        this.form.motor_year = ''
      }
    },
    getProvince() {
            this.loadderforms = true;
            axios.get(api_url+'/static/province')
                .then(response => {
                    this.provinces = response.data.data.provincy;
                    this.loadderforms = false;
                }).catch(error => {
                    console.log(error);
                });
    },
    changeProvince(event,label,target){
      this.form[target] = '';
      this[target] = '';

      if(event){
        this.form[label] = event._id;
        this.getCity(event._id);
      }else{
        this.form[label] = '';
        this.province_id = '';
      }
    },
    getCity(province) {
            axios.get(api_url+'/static/city/'+province)
                .then(response => {
                    this.cities = response.data.data.city;
                }).catch(error => {
                    console.log(error);
                });
    },
    changeCity(event,label){
      if(event){
        this.form[label] = event._id;
      }else{
        this.form[label] = '';
        this.city_id = '';
      }
    },
    changeHobby(event,label){
        if(event.length > 3) {
            console.log(' you can only select two', event)
            event.pop()
        }else{
            this.form.hobi = event.toString();
        }
    },
    getMotor() {
            axios.get(api_url+'/static/motor')
                .then(response => {
                    this.motor_types = response.data.data.bike_type;
                }).catch(error => {
                    console.log(error);
                });
    },
    changeMotor(event,label){
      if(event){
        this.form[label] = event._id;
      }else{
        this.form[label] = null;
      }
    },
    getMotors() {
            axios.get(api_url+'/static/motor')
                .then(response => {
                    this.varianMotors =  this.mapOptions(response.data.data.bike_type);
                }).catch(error => {
                    console.log(error);
                });
    },
    getMotorCategory() {
            this.loadderforms = false;
            axios.get(api_url+'/static/motor-category')
                .then(response => {
                    this.motorCategories = response.data.data.category_motor;
                    var others = {
                    title: "Lain-lain",
                    name: "lain-lain",
                    };
                    this.motorCategories.push(others);
                    this.loadderforms = false;
                }).catch(error => {
                    console.log(error);
                });
    },
    changeMotorCategory(event,label,target){
      this.motor_id = '';
      this.form.motor_id = '';

      if(event){
        this.form[target] = '';
        this[target] = '';
        this.form[label] = event.name;
        this.form.motor_category = event.name;
        this.motor_category = event.name;

        if (event.name == 'lain-lain'){
          //  this.getMotors();
        } else {
         this.getVarianMotor(event);
        }
      } else {
        this.form[label] = '';
        this.motor_category = '';
        this.form.motor_category = '';
      }
    },
    getVarianMotor(category) {
        axios.get(api_url+'/static/motor?type='+category.name)
            .then(response => {
                this.varianMotors =  this.mapOptions(response.data.data.motor);
            }).catch(error => {
                console.log(error);
            });
    },
    changeVarianMotor(event,label){
      if (event) {
        var motor = {id : event.id , name : event.title};
        this.form[label] = event.id;
      } else {
        this.form[label] = '';
        this.motor_id = '';
        this.form.motor_id = '';
      }
    },
    getClub() {
            axios.get(api_url+'/static/community')
                .then(response => {
                    this.clubs = response.data.data.community;
                }).catch(error => {
                    console.log(error);
                });
    },
    changeClub(event,label){
        if(event){
            if(event._id){
            this.form[label] = event._id;
            }
          console.log(label+' == ' + this.form[label])
        }
    },
    newClub(event,label ){
        this.form[label] = event.name;
    },
    mapOptions(data) {
      var items = data.map((item) => {
          return {id:item._id, title:item.name};
      });
      var uniqes = [ ...new Set(items) ];
      return uniqes;
    },
    getParam(param) {
      var url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
      for (var i=0;i<url.length;i++) {
          var params = url[i].split("=");
          if(params[0] == param)
            return params[1];
      }
      return false;
    },
    fetchPage() {
      axios.get(api_url+'/page?type=register-independent')
        .then(response => {
          this.pageContent = response.data
            // this.clubs = response.data.data.community;
        }).catch(error => {
            console.log(error);
        });
    }
  },
};
</script>
<style lang="scss">
  #registerpage{
    .vue-input-tag-wrapper .input-tag {
      background: #282828;
      border-radius: 10px;
      color: #FFFFFF;
      align-self: center;
      font-style: normal;
      font-weight: 300;
      font-size: 14px;
      line-height: 24px;
      padding: 5px 1rem 5px 1rem !important;
      margin-bottom: 0px;
    }
    @media (max-width: 768px) {
      .vue-input-tag-wrapper .input-tag {
        background: #E61B33;
        line-height: 22px;
        height: 25px;
        padding: 0px 1rem 0px 1rem !important;
      }
    }
  }
</style>
<style scoped lang="scss">
.otp-column {
  display: flex;
  justify-content: center;
  align-items: center;
}
.otp-card {
  width: 600px;
}
.otp-text-left {
  text-align: left;
}
.otp-card-body {
  padding: 2rem;
}
.otp-digit-wrapper {
  width: 100%;
  display: flex;
}
.digit-box {
  width: 100%;
  text-align: center;
  border: none;
  border-bottom: 2px solid #B4B4B4;
  font-size: 28px;
  color: #000000;
  font-weight: bold;
}
.otp-countdown {
  color: #727272;
}
.text-black {
  color: #000000;
}
.row-button{
    text-align: left;
    display: flex;
    .btn{
        margin:0;
        font-weight: bold;
        font-size: 16px;
        padding: 0;
        height: 38px;
        max-width: 115px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .btn-red{
        margin-right: auto;
    }
    .info-text{
        margin-right: 10px;
    }
    .sendback{
        margin-right: auto;
        .btn{
            min-width: 160px;
        }
    }
}
.btn-red {
  background-color: red;
  color: white;
}
.label-form-otp {
  color: black;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
}
.otp-desc {
  color: #3F3F3F;
  font-size: 15px;
  font-weight: 300;
  line-height: 24px;
}
.otp-number {
  color: #282828;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
}
.note {
  padding: 8px 0px;
  display: block;
  font-size: 12px;
  color:#333;
}
.input62{
  color:#333;
}
.text-red {
  color: #e61b33;
}
.colpage{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    .pageform{
        display: flex;
        justify-content: center;
        align-items: center;
        margin:0 20px;
        .numberpage{
            display: block;
            width: 35px; height: 35px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color:#4F4F4F;
            border-radius:100px;
            font-weight: bold;
        }
        .infopage{
            font-weight: bold;
            color:#4F4F4F;
            margin-left: 15px;
        }
    }
    .pageform.active{
        .numberpage{
            background-color:#7AE798;
        }
        .infopage{
            color:#7AE798;
        }
    }
}
#registerpage {
  background: #000000;
  font-family: Manrope;
  .card {
    background: #ffffff;
    border-radius: 10px;
    /* font-family: Inter; */
  }
  .title {
    color: #000000;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    margin-bottom: 1rem;
  }
  .label-form {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 24px;
    color: #3f3f3f;
  }
  .form-register {
    border-radius: 10px;
    border: 1px solid #dbdbdb;
    box-sizing: border-box;
    padding:11px;
    height: auto;
  }
  ::placeholder {
    color: #727272;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 24px;
  }
  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url(/images/arrow-select.png) no-repeat right white;
    background-position-x: 98.5%;
  }
  .form-check {
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 22px;
    color: #000000;
  }

  .btn {
    width: 161px;
    height: 50px;
  }
  .btn-white {
    border: 1px solid #dbdbdb;
    box-sizing: border-box;
    border-radius: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #e61b33;
  }
  a.btn-white{
    display: flex;
    align-items: center;
    justify-content: center;
    }

  .btn-red {
    background: #e61b33;
    border-radius: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #ffffff;
  }
  .title-row {
    background: #191919;
    opacity: 0.95;
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 42px;
    color: #ffffff;
  }
  .title-row-info {
    background: #1e1e1e;
  }
  .modal-content {
    background: #ffffff;
    border-radius: 10px;
  }
  .modal-header {
    border-bottom: unset;
  }
  .modal-title {
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    color: #e61b33;
  }
  .breadcrumb-image {
    max-height: 25px;
    display: inline-flex;
  }
  .breadcrumb-image-mobile {
    max-height: 25px;
    display: none;
  }
  .fa {
    cursor: pointer;
  }
  .fa-active {
    color: #4f4f4f;
  }
  .fa-not-active {
    color: #b4b4b4;
  }
  .row-eye {
    right: 35px;
    bottom: 155px;
    position: absolute;
    z-index: 1;
  }
  .row-password-eye {
    right: 35px;
    bottom: 265px;
    position: absolute;
    z-index: 1;
  }
  @media (max-width: 768px) {
    .otp-card {
      width: 100%;
    }
    .otp-text-left {
      text-align: left;
    }
    select {
      background-position-x: 95.5%;
    }
    .title {
      font-size: 18px;
    }
    .label-form {
      font-weight: 300;
    }
    .form-register {
      height: 40px;
    }
    .row-password-eye {
      bottom: 240px;
    }
    .row-eye {
      bottom: 145px;
    }
    .btn {
      width: 120px;
    }
    .modal-body {
      padding-left: 1.5rem !important;
      padding-right: 1.5rem !important;
    }
    .breadcrumb-image {
      display: none;
    }
    .breadcrumb-image-mobile {
      display: inline-flex;
    }
    // .digit-box {
    //   width: 2rem;
    // }
  }
}
</style>
